'use client'
import { useUser } from '@/app_lib/providers/UserProvider';
import { AdShieldScript } from '@/app_lib/scripts/AdShieldScript';
import { ArcSpanScript } from '@/app_lib/scripts/arcSpan';
import { BomboraScript } from '@/app_lib/scripts/bombora';
import { FreestarRecoveredScript } from '@/app_lib/scripts/FreestarRecoveredScript';
import { FreeStarScript } from '@/app_lib/scripts/freeStar';
import { NativoScript } from '@/app_lib/scripts/nativo/wrapper';

export const AdScripts = () => {
  const { hasConsent, personalizedAds } = useUser();
 return (
    <>
      {hasConsent && (
        <>
          <FreestarRecoveredScript />
          <FreeStarScript />
          <AdShieldScript />
        </>
      )}
      {personalizedAds  && (
        <>
          <ArcSpanScript />
          <BomboraScript />
          <NativoScript />
        </>
      )}
    </>
 )
};
